const oper = 'operative/';
const operPot = 'operative-potencial/';
const riesCre = 'riesgo-credito/';
const finAler = 'financiero-alerta/';
const form = 'formulacion/';
const asociatividad = 'asociatividad/';
const captacion = 'captacion-comercial/';
const colocacion = 'colocacion-comercial/';
const seg = 'seguimiento/';
const repor = 'reportes/';
const admin = 'administrador-cuestionarios/';
const adminGestion = 'administrador-gestion/';
const cuest = 'cuestionarios/';
const result = 'resultados/';
const clima = 'clima-laboral/';
const riesLiq = 'riesgo-liquidez/';
const proyFinan = 'proyecciones-financieras/';
const segPresu = 'seguimiento-presupuestal/';
const reporteN = 'reportes-normativos/'


export const environment = {
  googleAnalytics: 'G-F7G7WZ0WC0',
  // TODO: hay que cambiar el estatus a falso al trabajar en local.
  production: true,
  modules: [
    /**
     * Plataforma Riego Operativo
     */
    { identifier: 'ale-riesgooperativopotenciales', name: 'operative-potencial', route: '', submodules: [], module: 'operative-potencial', platform: 'risks-operative' },
    { identifier: 'ale-riesgooperativo', name: 'operative', route: '', submodules: [], module: 'operative', platform: 'risks-operative' },
    /**
     * Plataforma Riesgos
     */
    { identifier: 'ale-riesgofinanciero', name: 'financiero-alerta', route: '', submodules: [], module: 'financiero-alerta', platform: 'risks' },
    { identifier: 'ale-riesgodecrédito', name: 'riesgo-credito', route: '', submodules: [], module: 'riesgo-credito', platform: 'risks' },
    { identifier: 'ale-riesgodeliquidez', name: 'riesgo-liquidez', route: '', submodules: [], module: 'riesgo-liquidez', platform: 'risks' },
    { identifier: 'ale-normativos', name: 'reportes-normativos', route: '', submodules: [], module: 'reportes-normativos', platform: 'reports' },
    /**
     * Plataforma Gestión Estrategica
     */
    { identifier: 'ale-formulación', name: 'formulacion', route: '', submodules: [], module: 'formulacion', platform: 'strategic' },
    { identifier: 'ale-seguimiento', name: 'seguimiento', route: '', submodules: [], module: 'seguimiento', platform: 'strategic' },
    { identifier: 'ale-reportes', name: 'reportes', route: '', submodules: [], module: 'reportes', platform: 'strategic' },
    { identifier: 'ale-administrador', name: 'administrador-gestion', route: '', submodules: [], module: 'administrador-gestion', platform: 'strategic' },
    /**
     * Plataforma Questionarios
     */
    { identifier: 'ale-administradordecuestionarios', name: 'administrador-cuestionarios', route: '', submodules: [], module: 'administrador-cuestionarios', platform: 'questionnaire' },
    { identifier: 'ale-cuestionarios', name: 'cuestionarios', route: '', submodules: [], module: 'cuestionarios', platform: 'questionnaire' },
    { identifier: 'ale-resultadoscuestionarios', name: 'resultados', route: '', submodules: [], module: 'resultados', platform: 'questionnaire' },
    { identifier: 'ale-climalaboral', name: 'clima-laboral', route: '', submodules: [], module: 'clima-laboral', platform: 'questionnaire' },
    /**
     * Plataforma Comercial
     */
    { identifier: 'ale-asociatividad', name: 'asociatividad', route: '', submodules: [], module: 'asociatividad', platform: 'comercial' },
    { identifier: 'ale-captación', name: 'captacion-comercial', route: '', submodules: [], module: 'captacion-comercial', platform: 'comercial' },
    { identifier: 'ale-colocación', name: 'colocacion-comercial', route: '', submodules: [], module: 'colocacion-comercial', platform: 'comercial' },
    /**
     * Plataforma Seguimiento presupuestal
     */
    { identifier: 'ale-proyeccionesfinancieras', name: 'proyecciones-financieras', route: '', submodules: [], module: 'proyecciones-financieras', platform: 'seg-presupuestario' },
    { identifier: 'ale-seguimientopresupuestal', name: 'seguimiento-presupuestal', route: '', submodules: [], module: 'seguimiento-presupuestal', platform: 'seg-presupuestario' },
  ],
  submodules: [
    /**
     * Tableros del modulo operativo
     */
    { identifier: 'ale-matrizdeevento', name: 'matriz-eventos', route: oper + 'matriz-eventos', module: 'operative' },
    { identifier: 'ale-análisisdeeventos', name: 'analisis-eventos', route: oper + 'analisis-eventos', module: 'operative' },
    { identifier: 'ale-análisiscombinado', name: 'analisis-combinado', route: oper + 'analisis-combinado', module: 'operative' },
    { identifier: 'ale-mapadecalor', name: 'mapa-calor', route: oper + 'mapa-calor', module: 'operative' },
    /**
     * Tableros del modulo Operativo potencial
     */
    { identifier: 'ale-matrizdeeventospotenciales', name: 'matriz-eventos', route: operPot + 'matriz-eventos-pot', module: 'operative-potencial' },
    { identifier: 'ale-análisisdeeventospotenciales', name: 'analisis-eventos', route: operPot + 'analisis-eventos-pot', module: 'operative-potencial' },
    { identifier: 'ale-análisisdecombinado', name: 'analisis-combinado', route: operPot + 'analisis-combinado-pot', module: 'operative-potencial' },
    { identifier: 'ale-mapadecalor', name: 'mapa-calor', route: operPot + 'mapa-calor-pot', module: 'operative-potencial' },
    /**
     * Tableros del modulo Riegos de credito
     */
    { identifier: 'ale-tendenciadepérdida', name: 'tendencia-perdida', route: riesCre + 'tendencia-perdida', module: 'riesgo-credito' },
    { identifier: 'ale-matrizdetransición', name: 'matriz-transicion', route: riesCre + 'matriz-transicion', module: 'riesgo-credito' },
    { identifier: 'ale-cosechas', name: 'cosechas', route: riesCre + 'cosechas', module: 'riesgo-credito' },
    { identifier: 'ale-concentración', name: 'concentracion', route: riesCre + 'concentracion', module: 'riesgo-credito' },
    { identifier: 'ale-concentración_a', name: 'concentracion', route: riesCre + 'concentracionAT', module: 'riesgo-credito' },
    { identifier: 'ale-mayoresdeudores', name: 'mayores-deudores', route: riesCre + 'mayores-deudores', module: 'riesgo-credito' },
    { identifier: 'ale-mayoresdeudores_a', name: 'mayores-deudores', route: riesCre + 'mayores-deudoresAT', module: 'riesgo-credito' },
    { identifier: 'ale-cobertura', name: 'cobertura', route: riesCre + 'cobertura', module: 'riesgo-credito' },
    { identifier: 'ale-reservas', name: 'reserva-cartera', route: riesCre + 'reserva-cartera', module: 'riesgo-credito' },
    { identifier: 'ale-reportecrédito', name: 'reporte-credito', route: riesCre + 'reporte', module: 'riesgo-credito' },
    /**
     * Tableros del modulo Financiero alerta temprana
     */
    { identifier: 'ale-catálogodecuentas', name: 'catalogo-de-cuentas', route: finAler + 'catalogo-de-cuentas', module: 'financiero-alerta' },
    { identifier: 'ale-estadosfinancieros', name: 'estados-financieros', route: finAler + 'estados-financieros', module: 'financiero-alerta' },
    { identifier: 'ale-indicadoresfinancieros', name: 'indicadores-financieros', route: finAler + 'indicadores-financieros', module: 'financiero-alerta' },
    { identifier: 'ale-indicadoresperlas', name: 'indicadores-perlas', route: finAler + 'indicadores-perlas', module: 'financiero-alerta' },
    { identifier: 'ale-indicadoresdeproductividad', name: 'indicadores-productividad', route: finAler + 'indicadores-productividad', module: 'financiero-alerta' },
    { identifier: 'ale-indicadoresdecobertura', name: 'indicadores-cobertura', route: finAler + 'indicadores-cobertura', module: 'financiero-alerta' },
    { identifier: 'ale-cobertura', name: 'cobertura', route: finAler + 'cobertura', module: 'financiero-alerta' },
    { identifier: 'ale-activosponderados', name: 'activos-ponderados', route: finAler + 'activos-ponderados', module: 'financiero-alerta' },
    { identifier: 'ale-altadeplanesfinancieros', name: 'planes', route: finAler + 'planes', module: 'financiero-alerta' },
    { identifier: 'ale-seguimientoplanes_f', name: 'seguimiento-planes', route: finAler + 'seguimiento', module: 'financiero-alerta' },
    { identifier: 'ale-reportefinanciero', name: 'reporte-financiero', route: finAler + 'reporte-financiero', module: 'financiero-alerta' },
    /**
     * Tableros del modulo Reportes normativos
     */
    { identifier: 'ale-normativos', name: 'reportes', route: reporteN + 'reportes', module: 'reportes-normativos' },
    /**
     * Tableros del modulo operativo Formulacion estrategico
     */
    { identifier: 'ale-perspectivas', name: 'perspectivas', route: form + 'perspectivas', module: 'formulacion' },
    { identifier: 'ale-filosofíacorporativa', name: 'filosofia-corporativa', route: form + 'filosofiacorporativa', module: 'formulacion' },
    { identifier: 'ale-matrizfoda', name: 'matriz-foda', route: form + 'matriz-foda', module: 'formulacion' },
    { identifier: 'ale-matrizderiesgosyoportunidades', name: 'matriz-riesgos-oportunidades', route: form + 'matriz-riesgos-oportunidades', module: 'formulacion' },
    { identifier: 'ale-objetivos', name: 'objetivos', route: form + 'objetivos', module: 'formulacion' },
    { identifier: 'ale-indicadores-metas', name: 'indicadores-metas', route: form + 'indicadores-metas', module: 'formulacion' },
    { identifier: 'ale-alineamientoestratégico', name: 'alineamiento-estrategico', route: form + 'alineamiento-estrategico', module: 'formulacion' },
    { identifier: 'ale-altadeproyectos', name: 'alta-proyectos', route: form + 'alta-proyectos', module: 'formulacion' },
    { identifier: 'ale-proyectosestratégicos', name: 'proyectos-estrategicos', route: form + 'proyectos-estrategicos', module: 'formulacion' },
    { identifier: 'ale-cuadromandointegral', name: 'cuadro-mando-integral', route: form + 'cuadro-mando-integral', module: 'formulacion' },
    { identifier: 'ale-altadeplanes', name: 'alta-planes', route: form + 'alta-planes', module: 'formulacion' },
    { identifier: 'ale-altaactas', name: 'alta-actas', route: form + 'alta-actas', module: 'formulacion' },
    /**
     * Tableros del modulo Seguimiento estratégico
     */
    { identifier: 'ale-cuadromandointegral_s', name: 'cuadro-mando', route: seg + 'cuadro-mando', module: 'seguimiento' },
    { identifier: 'ale-objetivos_s', name: 'objetivos', route: seg + 'objetivos', module: 'seguimiento' },
    { identifier: 'ale-indicadores-metas_s', name: 'indicadores-metas', route: seg + 'indicadores-metas', module: 'seguimiento' },
    { identifier: 'ale-estrategia_s', name: 'estrategias', route: seg + 'estrategias', module: 'seguimiento' },
    { identifier: 'ale-proyectosestratégicos_s', name: 'proyectos-estrategicos', route: seg + 'proyectos-estrategicos', module: 'seguimiento' },
    { identifier: 'ale-planes_s', name: 'planes', route: seg + 'planes', module: 'seguimiento' },
    { identifier: 'ale-actas_s', name: 'actas', route: seg + 'actas', module: 'seguimiento' },
    /**
     * Tableros del modulo reportes estrategico
     */
    { identifier: 'ale-planestratégico', name: 'plan-estrategico', route: repor + 'plan-estrategico', module: 'reportes' },
    { identifier: 'ale-avancedeseguimientodelplan', name: 'avance-seguimiento', route: repor + 'avance-seguimiento', module: 'reportes' },    
    /**
     * Tableros del modulo Administrador Gestión
     */
    { identifier: 'ale-catálogos', name: 'catalogos', route: adminGestion + 'catalogos', module: 'administrador-gestion' },
    { identifier: 'ale-altadeplanes', name: 'alta-planes', route: adminGestion + 'alta-planes', module: 'administrador-gestion' },    
    /**
     * Tableros del modulo Cuestionarios
     */
    { identifier: 'ale-altacuestionarios', name: 'alta-cuestionarios', route: admin + 'alta', module: 'administrador-cuestionarios' },
    { identifier: 'ale-estructuración', name: 'estructuracion-cuestionarios', route: admin + 'estructuracion', module: 'administrador-cuestionarios' },
    { identifier: 'ale-ponderación', name: 'ponderacion-cuestionarios', route: admin + 'ponderacion', module: 'administrador-cuestionarios' },
    { identifier: 'ale-responsablesplanes', name: 'responsables-planes', route: admin + 'responsables-planes', module: 'administrador-cuestionarios' },
    /**
     * Tableros del modulo Cuestionarios resultados
     */
    { identifier: 'ale-asignación', name: 'asignacion', route: cuest + 'asignacion', module: 'cuestionarios' },
    { identifier: 'ale-cuestionariosasignados', name: 'cuestionarios-asignados', route: cuest + 'cuestionarios-asignados', module: 'cuestionarios' },
    { identifier: 'ale-cuestionarioclimalaboral', name: 'cuestionarioV2', route: cuest + 'cuestionario', module: 'cuestionarios' },
    { identifier: 'ale-calificación', name: 'calificacion', route: result + 'calificacion', module: 'resultados' },
    { identifier: 'ale-planes', name: 'planes', route: result + 'planes', module: 'resultados' },
    { identifier: 'ale-seguimientoplanes', name: 'seguimiento-planes', route: result + 'seguimiento-planes', module: 'resultados' },
    { identifier: 'ale-reporte', name: 'reporte', route: result + 'reporte', module: 'resultados' },
    /**
     * Tableros del modulo Cuestionarios clima laboral
     */
    { identifier: 'ale-metodología', name: 'metodologia', route: clima + 'metodologia', module: 'clima-laboral' },
    { identifier: 'ale-resultados', name: 'resultados-clima', route: clima + 'resultados', module: 'clima-laboral' },
    { identifier: 'ale-análisiscombinado_cl', name: 'analisis-combinado', route: clima + 'analisis-combinado', module: 'clima-laboral' },
    { identifier: 'ale-catálogodimensiones', name: 'catalogo-dimensiones', route: clima + 'catalogo-dimensiones', module: 'clima-laboral' },
    { identifier: 'ale-plandeacción_cl', name: 'plan-accion', route: clima + 'plan-accion', module: 'clima-laboral' },
    { identifier: 'ale-seguimientoplanes_cl', name: 'seguimiento-plan', route: clima + 'seguimiento-plan', module: 'clima-laboral' },
    { identifier: 'ale-reporte_cl', name: 'informe', route: clima + 'informe', module: 'clima-laboral' },
    { identifier: 'ale-perfil_cl', name: 'perfil', route: clima + 'perfil', module: 'clima-laboral' },
    /**
     * Tableros del modulo Comercial
     */
    { identifier: 'ale-tendencia_as', name: 'tendencia', route: asociatividad + 'tendencia', module:'asociatividad'},
    { identifier: 'ale-perfil_as', name: 'perfil', route: asociatividad + 'perfil', module: 'asociatividad' },
    { identifier: 'ale-metas_as', name: 'meta', route: asociatividad + 'metas', module: 'asociatividad' },
    /**
     * Tableros del modulo Captacion
     */
    { identifier: 'ale-tendencia_ca', name: 'tendencia', route: captacion + 'tendencia', module:'captacion-comercial'},
    { identifier: 'ale-perfil_ca', name: 'perfil', route: captacion + 'perfil', module:'captacion-comercial'},
    { identifier: 'ale-metas_ca', name: 'meta', route: captacion + 'metas', module:'captacion-comercial'},
    /**
     * Tableros del modulo Colocacion
     */
    { identifier: 'ale-tendencia_cr', name: 'tendencia', route: colocacion + 'tendencia', module:'colocacion-comercial'},
    { identifier: 'ale-perfil_cr', name: 'perfil', route: colocacion + 'perfil', module:'colocacion-comercial'},
    { identifier: 'ale-metas_cr', name: 'meta', route: colocacion + 'metas', module:'colocacion-comercial'},
    { identifier: 'ale-indicadores|anexo1', name: 'indicadores-A1', route: colocacion + 'indicadores-A1', module:'colocacion-comercial'},
    { identifier: 'ale-indicadores|anexo3', name: 'indicadores-A3', route: colocacion + 'indicadores-A3', module:'colocacion-comercial'},
    /**
     * Tableros del modulo Proyecciones financieras
     */
    {identifier: 'ale-configuracióncatálogo', name: 'configCatalogo', route: proyFinan + 'configuracion-catalogo', module: 'proyecciones-financieras'},
    {identifier: 'ale-configuraciónindicadores', name: 'configIndicadores', route: proyFinan + 'configuracion-indicadores', module: 'proyecciones-financieras'},
    {identifier: 'ale-cargainformación', name: 'cargaInformacion', route: proyFinan + 'carga-informacion', module: 'proyecciones-financieras'},
    {identifier: 'ale-cargainformación', name: 'proyecciones', route: proyFinan + 'proyecciones', module: 'proyecciones-financieras'},
    {identifier: 'ale-escenariosproyectados', name: 'escenarios-proyectados', route: proyFinan + 'escenarios-proyectados', module: 'proyecciones-financieras'},
    /**
     * Tableros del modulo Seguimiento presupuestal -Proyecciones
     */
    { identifier: 'ale-catalógodecuentas_sp', name: 'catalogo-cuentas', route: segPresu + 'catalogo-cuentas', module: 'seguimiento-presupuestal'},
    { identifier: 'ale-estadosfinancieros_s', name: 'estados-financieros', route: segPresu + 'estados-financieros', module: 'seguimiento-presupuestal'},
    { identifier: 'ale-razonesfinancieras', name: 'razones-financieras', route: segPresu + 'razones-financieras', module: 'seguimiento-presupuestal'},
    { identifier: 'ale-análisisporsegmentos', name: 'analisis-segmento', route: segPresu + 'analisis-segmento', module: 'seguimiento-presupuestal'},
    // { identifier: 'ale-estadosfinancieros_s', name: 'analisis-sucursales', route: segPresu + 'analisis-sucursales', module: 'seguimiento-presupuestal'},
    //Riesgo liquidez
    { identifier: 'ale-gap', name: 'gap', route: riesLiq + 'gap', module:'riesgo-liquidez'},
    { identifier: 'ale-gap_m', name: 'gap', route: riesLiq + 'gap-airac', module:'riesgo-liquidez'},
    { identifier: 'ale-razonesdeliquidez', name: 'razones-liquidez', route: riesLiq + 'razones-liquidez', module:'riesgo-liquidez'},
    { identifier: 'ale-volatilidad', name: 'volatilidad', route: riesLiq + 'volatilidad', module:'riesgo-liquidez'},
    { identifier: 'ale-cobertura_l', name: 'cobertura', route: riesLiq + 'cobertura', module:'riesgo-liquidez'},
    { identifier: 'ale-concentración_l', name: 'concentracion', route: riesLiq + 'concentracion', module:'riesgo-liquidez'},
    //TODO: Tableros en deserrollo para chorotega
    { identifier: 'ale-calcedeplazos', name: 'calces-plazos', route: riesLiq + 'calces-plazos', module:'riesgo-liquidez'},

    //TODO: Tableros en desarrollo para Airac
    { identifier: 'ale-mayoresdepositantes', name: 'mayores-depositantes', route: riesLiq + 'mayores-depositantes', module:'riesgo-liquidez'},
  ],
  /**
   * Api del operativo
   */
  apiOperativoDev: "https://www.dev.api.operative.aleema.friedrichlatam.com/api/v1/",
  /**
   * Api para riego de crédito
   */
  // SECURIC
  baseUrlRiesgos: 'https://dev.sicuric-ws.friedrichlatam.com/sicws/webapi', // ws nuevo
  // Alerta temprana
  api_alertaTemprana: 'alertaTempranaDev',
  /**
   * Api de gestión estrategica
   */
  apiURL_institucion: 'https://dev.api.gestion-estrategica.aleema.friedrichlatam.com/api/v1/',
  // apiURL_institucion: 'https://api.gestion-estrategica.aleema.friedrichlatam.com/api/v1/',
  apiURL_gestion: 'gestionDev',
  /**
   * Api de cuestionarios
   */
  api_cuestionarios: 'cuestionariosDev',
  api_cuestionarios_rest: 'https://dev.api.survey.aleema.friedrichlatam.com/api/v1/management/',
  api_cuestionariosA_rest: 'https://dev.api.survey.aleema.friedrichlatam.com/api/v1/',
  /**
   * Api comercial
   */
  api_comercial_rest: 'https://dev.api.commercial.aleema.friedrichlatam.com/v1/',
  api_comercial: 'comercialDev',
  /**
   * APi alema riesgos
   */
  api_aleemaRiesgos: 'aleemaRiesgosDevC',
  api_aleemaRiesgosGeneral: 'aleemaRiesgosGeneralDev',
  api_aleemaRiesgosGeneralRest: 'https://dev.api.risk.aleema.friedrichlatam.com/v1/',
  /**
   * Api plataformas de proyecciones
   */
  api_proyecciones: 'http://146.190.136.161:5000/',
  /**
   * Api seguimieto presupuestal
   */
  api_formulador: 'https://api.dev.formulador.aleema.friedrichlatam.com/',
  /**
   * Api general
   */
  api_general: 'https://dev.api.bi.aleema.friedrichlatam.com/'
}
